import { DownloadPageLayout } from '@bpm-web-app/components';
import { Favorites } from '@bpm-web-app/components/pages';

export default function FavoritesPage({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <Favorites />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Favorites',
        },
    };
}
